














import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {PartnerModel} from '@/models/partner.model';

@Component({})
export default class ChallengerDetailPartner extends Vue {
  @Prop({required: true}) partner!: PartnerModel;
  show: boolean = false;
}
